export const setTheme = (theme) => {
    if (theme !== undefined) {
        localStorage.otomatic_ai_theme = theme;
    } else {
        localStorage.removeItem("otomatic_ai_theme");
    }

    updateThemeSelector();
};

export const isDarkMode = () => {
    return false;
    return localStorage.otomatic_ai_theme === "dark" || (!("otomatic_ai_theme" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches);
};

export const isSystemTheme = () => {
    return localStorage.otomatic_ai_theme === undefined;
};

const updateThemeSelector = () => {
    document.documentElement.classList.toggle("otomatic-ai-dark", isDarkMode());
};

window.addEventListener("load", (event) => {
    updateThemeSelector();

    const pcs = window.matchMedia("(prefers-color-scheme: dark)");
    pcs.onchange = () => {
        updateThemeSelector();
    };
});
